import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { logErrorBoundaryError } from 'lib/errors'
import ErrorComponent from 'components/Errors/ErrorComponent'

/**
 * Component to render fallback placeholder when error boundary catches error.
 * Content can be anything, including function that will receive props.
 * The props will contain:
 * componentStack: string
 * error: object
 * erroredComponentProps: object
 * @returns {XML}
 * @param props
 */
export const ErrorPlaceholder = (props) => {
    return <ErrorComponent error={props.error} />
}

export const ErrorPlaceholderNoRender = () => {
    return null
}

/**
 * ErrorBoundary HoC to wrap any component to catch any errors occurring within wrapped component.
 * This is basically the same as react-error-boundary component's withErrorBoundary, with the exception
 * that we are passing props of errored component to the fallback component.
 * @param Component
 * @param FallbackComponent
 * @returns {function({props?: *})}
 */
export const withErrorBoundary = (Component, FallbackComponent) => {
    const WithErrorBoundary = (props) => {
        if (FallbackComponent !== false) {
            FallbackComponent = FallbackComponent || ErrorPlaceholder
        } else {
            FallbackComponent = ErrorPlaceholderNoRender
        }

        return (
            <ErrorBoundary
                FallbackComponent={FallbackComponent}
                onError={logErrorBoundaryError}
            >
                <Component {...props} />
            </ErrorBoundary>
        )
    }

    return WithErrorBoundary
}

export const withErrorBoundaryNoRender = (Component) => {
    return withErrorBoundary(Component, false)
}
